// extracted by mini-css-extract-plugin
export default {"root":"AFFTC2ULT1_lsz89CmLQ"};